<h2 mat-dialog-title>Modificar contraseña</h2>
<mat-dialog-content class="mat-typography">
  <form [formGroup]="form">
    <mat-form-field class='formField'>
      <mat-label>Contraseña</mat-label>
      <input matInput placeholder="Contraseña" formControlName="password" [(value)]="password" required>
    </mat-form-field>
    <p class='mini'>* Debe tener mínimo 8 caracteres.</p>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancelar</button>
  <button mat-button (click)="save()">Modificar</button>
</mat-dialog-actions>
